<div class="pagination">
    <!-- Page Size Selector - Tailwind z-dropdown-menu -->
    <div class="pagination__page-size">
        <label class="pagination__page-size-label">Show:</label>
        <div class="pagination__page-size-dropdown-host">
            <z-dropdown-menu [class]="'pagination__page-size-dropdown'" [closeOnScroll]="true">
                <button
                    dropdown-trigger
                    type="button"
                    class="pagination__page-size-trigger"
                    aria-label="Items per page"
                    aria-haspopup="listbox"
                >
                    <span class="pagination__page-size-value">{{ pageSize }}</span>
                    <span class="pagination__page-size-chevron" aria-hidden="true"></span>
                </button>
                @for (option of pageSizeOptions; track option) {
                    <z-dropdown-menu-item
                        [selected]="option === pageSize"
                        (click)="selectPageSize(option)"
                    >
                        <span class="pagination__page-size-option">{{ option }}</span>
                        @if (option === pageSize) {
                            <span class="pagination__page-size-check" aria-hidden="true">✓</span>
                        }
                    </z-dropdown-menu-item>
                }
            </z-dropdown-menu>
        </div>
        <span class="pagination__page-size-text">per page</span>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination__controls">
        <!-- Previous Button -->
        <button
            class="pagination__button pagination__button--arrow"
            [class.pagination__button--disabled]="isDisabled('prev')"
            [disabled]="isDisabled('prev')"
            (click)="handlePreviousPage()"
            title="Previous page"
        >
            <app-svg-icon name="chevron_left" size="lg" />
        </button>

        <!-- Page Numbers -->
        @for (page of visiblePages; track page) {
            @if (isEllipsis(page)) {
                <span class="pagination__ellipsis">...</span>
            } @else {
                <button
                    class="pagination__button pagination__button--number"
                    [class.pagination__button--active]="isCurrentPage(page)"
                    (click)="handlePageChange(page)"
                >
                    {{ page }}
                </button>
            }
        }

        <!-- Next Button -->
        <button
            class="pagination__button pagination__button--arrow"
            [class.pagination__button--disabled]="isDisabled('next')"
            [disabled]="isDisabled('next')"
            (click)="handleNextPage()"
            title="Next page"
        >
            <app-svg-icon name="chevron_right" size="lg" />
        </button>
    </div>

    <!-- Total Items Info -->
    <div class="pagination__info">
        Showing {{ (currentPage - 1) * pageSize + 1 }} to
        {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} entries
    </div>
</div>
